import { defineStore } from 'pinia'

// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useEvent = defineStore('event', {
  state: () => ({
    // all these properties will have their type inferred automatically
    data: {
      decoded_settings: {
        currency: '',
      },
    },
  }),

  getters: {
    currencySign: (state) => {
      if (state.data.decoded_settings.currency === 'BGN') {
        return 'BGN'
      }
      if (state.data.decoded_settings.currency === 'GBP') {
        return '£'
      }
      return '€'
    },
  },
})
